// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.addStyle {\n  color: #409EFF;\n  cursor: pointer;\n  font-size: 18px;\n}\n.deleteStyle {\n  color: #F56C6C;\n  cursor: pointer;\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
